import { useRef, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";

export function useRecorder(onText) {
  const [recording, setRecording] = useState(false);
  const [busy, setBusy] = useState(false);
  const mr = useRef(null);
  const chunks = useRef([]);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const rec = new MediaRecorder(stream);
      chunks.current = [];
      rec.ondataavailable = (e) => e.data.size && chunks.current.push(e.data);
      rec.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        const blob = new Blob(chunks.current, { type: rec.mimeType || "audio/webm" });
        if (blob.size < 1000) return;
        setBusy(true);
        try {
          const form = new FormData();
          form.append("audio", blob, "resume.webm");
          const { data } = await api.post("/resume/transcribe", form, { headers: { "Content-Type": "multipart/form-data" } });
          if (data.text?.trim()) onText(data.text.trim());
        } catch { toast.error("Couldn't understand that recording. Try again or type instead."); }
        finally { setBusy(false); }
      };
      rec.start();
      mr.current = rec;
      setRecording(true);
    } catch { toast.error("Microphone access is needed to speak your resume. You can type instead."); }
  };
  const stop = () => { mr.current?.stop(); setRecording(false); };
  return { recording, busy, toggle: () => (recording ? stop() : start()) };
}
